import webrtcAdapter from 'webrtc-adapter';

export const pipRequiresGestureTask = () => webrtcAdapter.browserDetails.browser === 'safari';
